const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");

const getIsVehicleRegistrationByCitroenSelected = registrationType => {
  return registrationType === VEHICLE_REGISTRATION_METHOD.CITROEN;
};

module.exports = { getIsVehicleRegistrationByCitroenSelected };
